import React from 'react';
import { Link } from 'react-router-dom';
import SeoHead from '../components/SeoHead';

export default function NotFoundPage() {
  return (
    <>
      <SeoHead
        title="Siden blev ikke fundet (404) - KROMIX A/S"
        description="Vi kunne desværre ikke finde siden, du ledte efter."
      />

      <section className="py-24 sm:py-32 bg-[#F4EFE5] text-center">
        <div className="max-w-2xl mx-auto px-4 sm:px-6">
          <div className="w-20 h-20 rounded-full bg-[#FCFAF5] border border-[#DED3C0] text-[#B98262] flex items-center justify-center text-3xl mx-auto mb-6 shadow-xs">
            <i className="fa-solid fa-compass-slash" aria-hidden="true" />
          </div>

          <span className="text-xs font-bold uppercase tracking-widest text-[#B98262] block mb-1">
            Fejl 404
          </span>
          <h1 className="text-3xl sm:text-4xl font-extrabold text-[#39463A] tracking-tight">
            Vi kunne ikke finde siden
          </h1>
          <p className="text-sm text-[#39463A]/80 mt-3 max-w-md mx-auto leading-relaxed">
            Den side, du forsøger at tilgå, er enten flyttet, slettet eller findes ikke. Benyt venligst et af nedenstående links for at finde det, du søger.
          </p>

          <div className="mt-8 flex flex-wrap justify-center gap-3">
            <Link
              to="/"
              className="px-5 py-3 rounded-xl bg-[#71806A] hover:bg-[#5C6A56] text-white text-xs font-bold uppercase tracking-wider transition-colors shadow-xs"
            >
              Gå til forsiden
            </Link>
            <Link
              to="/hundefoder"
              className="px-5 py-3 rounded-xl bg-[#FCFAF5] hover:bg-[#F4EFE5] border border-[#DED3C0] text-[#39463A] text-xs font-bold uppercase tracking-wider transition-colors shadow-xs"
            >
              Se hundefoder
            </Link>
            <Link
              to="/forhandlere"
              className="px-5 py-3 rounded-xl bg-[#FCFAF5] hover:bg-[#F4EFE5] border border-[#DED3C0] text-[#39463A] text-xs font-bold uppercase tracking-wider transition-colors shadow-xs"
            >
              Find forhandler
            </Link>
            <Link
              to="/kontakt"
              className="px-5 py-3 rounded-xl bg-[#FCFAF5] hover:bg-[#F4EFE5] border border-[#DED3C0] text-[#39463A] text-xs font-bold uppercase tracking-wider transition-colors shadow-xs"
            >
              Kontakt os
            </Link>
          </div>
        </div>
      </section>
    </>
  );
}
